import * as tslib_1 from "tslib";
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { LogDeviceModel } from '../../../models/log-device.model';
import { AbreCuentasService } from '../../abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from '../../communicator/channel-communicator/channel-communicator.service';
import { PlatformCommunicatorAuthService, } from '../../communicator/platform-communicator/platform-communicator.auth.service';
import { ParametersService } from '../../parameters/parameters.service';
import { RequestService } from '../../request/request-onboarding.service';
import { CryptoVaultService } from '../crypto-vault/crypto-vault.service';
import { FirmlyApprovedService } from '../../firmly-approved/firmly-approved.service';
import { ResponseBiocatchGeo } from 'src/app/shared/models/biocatch-context.model';
import { BehaviorSubject, Observable } from 'rxjs';
var BioCatchService = /** @class */ (function () {
    /**
     * Constructor of the component.
     *
     * @param {AbreCuentasService}         abreCuentasService         Injectable abreCuentasService service.
     * @param {ChannelCommunicatorService} channelCommunicatorService Injectable channelCommunicatorService service.
     * @param {RequestService}             requestService             Injectable requestService service.
     */
    function BioCatchService(abreCuentasService, channelCommunicatorService, requestService, authService, parametersService, firmlyApprovedService, cryptoVaultService) {
        this.abreCuentasService = abreCuentasService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.requestService = requestService;
        this.authService = authService;
        this.parametersService = parametersService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.cryptoVaultService = cryptoVaultService;
        /**
         * Declaración de la variable document, contexto del navegador
         *
         * *Set document variable, navigator context*
         *
         * @access              public
         * @type                {string}
         */
        this.document = window.document;
        /**
         * Declaración de la variable cdApi como object, estrucutura del script
         *
         * *Set cdApi variable as object, script structure*
         *
         * @access              public
         * @type                {object}
         */
        this.cdApi = {
            resetSessionNumber: function () { return; },
            setCustomerSessionId: function (_csid) { return; },
            changeContext: function (_context) { return; },
            getCSID: function () { return; },
        };
        this.ppidIsReady$ = new BehaviorSubject(false);
    }
    BioCatchService.prototype.getUserPPID = function () {
        return this.userPPID;
    };
    /**
     * Función para inicializar la configuración para biocatch
     *
     * *Sets up biocatch config*
     *
     * @param {string} initialContext
     */
    BioCatchService.prototype.init = function (initialContext, chanelId, isLogged) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var settingName, settingName, bioCatchConfig, sessionId, allies_1, ally, isOriginal;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLogin = isLogged;
                        if (chanelId !== CHANNEL.PORTALALLIES.CODE) {
                            this.isAppUnica = chanelId === CHANNEL.SUPERAPP.CODE ? true : false;
                            settingName = this.isAppUnica ? OpEnum.BIOCATCH_BODY_FIELDS_APP : OpEnum.BIOCATCH_BODY_FIELDS_PORTAL;
                            this.bodyFields = this.parametersService.getSetting(settingName);
                        }
                        else {
                            settingName = OpEnum.BIOCATCH_BODY_FIELDS_ALLIES;
                            this.bodyFields = this.parametersService.getSetting(settingName);
                        }
                        bioCatchConfig = this.abreCuentasService.getBioCatchConfig();
                        sessionId = this.authService.getSessionId();
                        if (!(this.isAppUnica && !this.isLogin)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.injectScriptsAppUnica(bioCatchConfig)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.injectScriptPortal(bioCatchConfig, sessionId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 3:
                        if (!(this.isAppUnica && this.isLogin)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.injectScriptsAppUnica(bioCatchConfig)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 5:
                        if (!(chanelId === CHANNEL.PORTALALLIES.CODE)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.injectScriptPortal(bioCatchConfig, sessionId)];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, this.requestService.documentsAllies()
                                .then(function (res) { return allies_1 = res.Ally; })
                                .catch(function (err) { return console.log(err); })];
                    case 7:
                        _a.sent();
                        ally = allies_1.filter(function (item) { return item.code_Ally === _this.abreCuentasService.getAllyCode(); });
                        this.allyname = ally[0].name_Ally;
                        this.nitAlly = ally[0].nit_Ally;
                        _a.label = 8;
                    case 8:
                        if (!this.isLogin) return [3 /*break*/, 10];
                        // await this.injectScriptPortal(bioCatchConfig, sessionId);
                        this.currentCSID = this.abreCuentasService.getCSID();
                        return [4 /*yield*/, this.callPpid()];
                    case 9:
                        _a.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        this.setPpidIsReady(true);
                        _a.label = 11;
                    case 11:
                        isOriginal = this.isAppUnica && !this.isLogin;
                        setTimeout(function () {
                            var product = _this.abreCuentasService.getproductSelected();
                            var product_code = product ? product.product_code : undefined;
                            _this.changeContext(initialContext, _this.firmlyApprovedService.isEmpty() && _this.firmlyApprovedService.getOfferType_Channel() === 'En_firme' ?
                                product_code : undefined, isOriginal, _this.isEvidenteCase());
                            /* (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme')
                              ? this.abreCuentasService.getproductSelected()?.product_code as ProductsBiocatchEnum
                              : undefined, */
                        }, 1000);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función para cargar los scripts para portal
     *
     * *Loads portal scripts function*
     *
     * @param {BioCatchConfigModel} bioCatchConfig
     * @param {string} sessionId
     */
    BioCatchService.prototype.injectScriptPortal = function (bioCatchConfig, sessionId) {
        var _this = this;
        this.loadScript(bioCatchConfig.scriptUrl)
            .then(function () {
            _this.cdApi = _this.document.defaultView ? _this.document.defaultView['cdApi'] : {};
            _this.resetSessionNumber();
            _this.setSessionId(sessionId);
            return true;
        });
    };
    /**
     * Función para cargar los scripts para AppUnica
     *
     * *Loads appunica scripts function*
     *
     * @param {BioCatchConfigModel} bioCatchConfig
     */
    BioCatchService.prototype.injectScriptsAppUnica = function (bioCatchConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (bioCatchConfig.bridgeUrl === undefined || bioCatchConfig.slaveUrl === undefined) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.loadScript(bioCatchConfig.bridgeUrl)
                                .then(function () {
                                return true;
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadScript(bioCatchConfig.slaveUrl)
                                .then(function () {
                                return true;
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función para cargar los scripts para biocatch
     *
     * *Loads biocatch scripts function*
     *
     * @param {string} url
     */
    BioCatchService.prototype.loadScript = function (url) {
        var script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.async = false;
        script.src = url;
        this.document.body.appendChild(script);
        return new Promise(function (resolve) {
            script.onload = function () { return resolve('loaded'); };
        });
    };
    /**
     * Función para reiniciar el número de sesión de Biocatch
     *
     * *Reset session number for biocatch*
     *
     */
    BioCatchService.prototype.resetSessionNumber = function () {
        this.cdApi.resetSessionNumber();
    };
    /**
     * Función para inicializar el Id de la sesión para biocatch
     *
     * *Sets session id for biocatch*
     *
     *  @returns {string}
     */
    BioCatchService.prototype.setSessionId = function (sessionId) {
        this.currentCSID = sessionId;
        this.cdApi.setCustomerSessionId(sessionId);
    };
    /**
     * Función para obtener la puntuación actual ip dirección
     *
     * *Gets current score Ip*
     *
     *  @returns {string}
     */
    BioCatchService.prototype.getCurrentScoreIp = function () {
        if (!!this.currentScoreInfo && !!this.currentScoreInfo.ip) {
            return this.currentScoreInfo.ip;
        }
        return '';
    };
    /**
     * Función para obtener la configuración de Biocatch
     *
     * *Get biocatch info function*
     *
     * @returns {string}
     */
    BioCatchService.prototype.getBiocatchInfo = function () {
        if (!!this.currentScoreInfo) {
            return this.currentScoreInfo;
        }
        return '';
    };
    /**
     * Devuelve el estado de consumo del servicio
     * de Geolocalización
     * True - Funcionó correctamente el servicio
     * False - Falló el servicio
     */
    BioCatchService.prototype.getGeoServiceComplete = function () {
        return this.geoServiceComplete;
    };
    /**
     * Función para cambiar el contexto cambio de pantalla a nivel de biocatch
     *
     * *Change context function*
     *
     * @returns {Promise}
     */
    BioCatchService.prototype.changeContext = function (context, product, isOriginal, isPreloginOnly) {
        if (isOriginal === void 0) { isOriginal = true; }
        if (isPreloginOnly === void 0) { isPreloginOnly = false; }
        if ((this.isAppUnica && !this.isLogin && isOriginal)
            || (this.isAppUnica && !this.isLogin && isOriginal && product === ProductsBiocatchEnum.VIV)) {
            if (isOriginal && product && product === ProductsBiocatchEnum.VIV) {
                context = this.buildContext(context, product);
            }
            else {
                context = context.charAt(0).toUpperCase() + context.slice(1);
            }
            this.cdApi.changeContext(context);
        }
        else if ((this.isLogin && !isOriginal && !this.isEvidenteCase()) || (this.isEvidenteCase() && isPreloginOnly)) {
            var contextParam = this.buildContext(context, product);
            biocatchChangeContext(contextParam);
        }
    };
    /**
     * Arma el contexto correcto para biocatch apartir del paso y producto.
     *
     * *Form the correct context biocactch using step and product.*
     * @param {string|SteStepBiocatchEnum} step
     * @param {ProductsBiocatchEnum} product
     * @returns {string} Contexto biocatch armado segun la HU.
     *
     * * Biocatch context formed like to the definition. *
     */
    BioCatchService.prototype.buildContext = function (step, product) {
        var isMulti = this.abreCuentasService.viewOptionMultiProduct;
        var contextParams = this.parametersService.getBiocatchContextParams();
        var channelId = this.channelCommunicatorService.getChannelId();
        var context = '';
        if (this.isLogin) {
            context = "" + (this.isAppUnica ? contextParams.baseContext.app : contextParams.baseContext.web);
            if (isMulti) {
                return context + "_" + step + "_MUL";
            }
        }
        else if (channelId === '163') {
            context = contextParams.baseContext.app_allies;
            var context2 = contextParams.baseContext.app_allies2;
            return "" + context + this.allyname + context2 + "_" + step + (product == undefined ? '' : '_' + product);
        }
        else if (isMulti) {
            context = "" + (this.isAppUnica ? contextParams.baseContext.app_pre : contextParams.baseContext.web_pre);
            return context + "_" + step + "_MUL";
        }
        else {
            context = "" + (this.isAppUnica ? contextParams.baseContext.app_pre : contextParams.baseContext.web_pre);
        }
        return context + "_" + step + (!!product ? '_' + contextParams.products[product] : '');
    };
    /**
     * Función para revisar el origen del país
     *
     * *Check country function*
     *
     * @param {boolean} showLoading
     * @returns {Promise}
     */
    BioCatchService.prototype.checkCountry = function (showLoading) {
        var _this = this;
        return this.getScore(showLoading).then(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var geoLocation;
            return tslib_1.__generator(this, function (_a) {
                if (result['ipGeoCountry'] === undefined && result['ipGeoCity'] === undefined) {
                    console.warn('Formateando Geolocalización por falla en el servicio...');
                    result = this.validateGetScore(result);
                    this.geoServiceComplete = false;
                    this.saveDataInBitacora(StepBiocatchEnum.service_down);
                }
                else {
                    this.geoServiceComplete = true;
                    this.saveDataInBitacora(StepBiocatchEnum.service_up);
                }
                /* const contextData = JSON.stringify(result);
                this.saveDataInBitacora(`Data service Geo: ${contextData}`); */
                this.currentScoreInfo = result;
                result.rule = 'country';
                result.ip_geo_country = result.ipGeoCountry;
                geoLocation = result.ipGeoLatitude + "," + result.ipGeoLongtitude;
                this.abreCuentasService.setGeoLocation(geoLocation);
                return [2 /*return*/, this.checkParameterResults({ data: result }, showLoading)];
            });
        }); });
    };
    /**
     * Función que permite ajustar el JSON recibido del servicio de Geolocalización,
     * que por fallas en el servicio de Geo no llega completo, permitiendo así
     * completar todos los parámetros que se esperan para poder continuar el flujo
     * sin inconvenientes.
     * @param {any} dataGetScore - JSON incompleto recibido del servicio de Geo.
     * @returns {ResponseBiocatchGeo} - JSON con todos los parámetros ajustados.
     */
    BioCatchService.prototype.validateGetScore = function (dataGetScore) {
        var newData = new ResponseBiocatchGeo();
        Object.keys(dataGetScore).map(function (key) { return newData[key] = dataGetScore[key]; });
        return newData;
    };
    /**
     * Función para revisar la puntuación
     *
     * *Check score function*
     *
     * @param {boolean} showLoading
     * @returns {Promise}
     */
    BioCatchService.prototype.checkScore = function (showLoading) {
        var _this = this;
        return this.getScore(showLoading).then(function (result) {
            console.log('Result Score: ', result);
            _this.cryptoVaultService.refreshKeyCrypto();
            _this.currentScoreInfo = result;
            result.rule = 'score';
            result.ip_geo_country = result.ipGeoCountry;
            var bitacoraEvent = "geo_bioscore_" + _this.currentScoreInfo.score;
            _this.saveDataInBitacora(bitacoraEvent, showLoading);
            return _this.checkParameterResults({ data: result }, showLoading);
        });
    };
    /**
     * Función para obtener la puntuación
     *
     * *Gets score function*
     *
     * @param {string} activityType
     * @param {boolean} _showLoading
     *
     * @returns {Promise}
     */
    BioCatchService.prototype.getScore = function (_showLoading) {
        console.warn('Ya ingresó a GetScore');
        if (this.currentCSID === null || this.currentCSID === '') {
            throw new Error('currentCSID must be initialized');
        }
        if (!!this.cdApi) {
            console.warn('Ingresó a validaciones GetScore...');
            var activityType = this.isLogin ? this.bodyFields.activity_type_post : this.bodyFields.activity_type_pre;
            var config = this.abreCuentasService.getBioCatchConfig();
            var channel = this.channelCommunicatorService.getChannelId();
            var product = this.abreCuentasService.getproductSelected().product_type;
            var brand = this.bodyFields.brand;
            this.bodyFields.payeeAccountType = this.nitAlly;
            var ppid = this.isLogin ? this.userPPID : config.uuid;
            var csid = (!this.isLogin && this.isAppUnica) ? this.currentCSID : this.abreCuentasService.getCSID();
            var solution = this.isLogin ? this.bodyFields.method_description : config.solution;
            var applicationId = this.isLogin ? undefined : channel + "-" + product;
            var ip = this.abreCuentasService.getIp();
            var deviceModel = this.abreCuentasService.getDeviceInfo().model;
            var birthDate = void 0;
            if ((this.abreCuentasService.getCustomerData() && Object.keys(this.abreCuentasService.getCustomerData()).length !== 0)) {
                birthDate = this.abreCuentasService.getCustomerData().basic.birthdate;
            }
            else {
                birthDate = this.abreCuentasService.getDocumentInfo().birthdate;
            }
            try {
                birthDate = new Date(birthDate.split('/').reverse().join('-')).toString();
            }
            catch (_a) {
                birthDate = undefined;
            }
            var birthYear = birthDate ? new Date(birthDate).getFullYear().toString() : undefined;
            return this.requestService.getScore(config, this.bodyFields, csid, activityType, brand, ppid, solution, deviceModel, ip, applicationId, birthYear);
        }
        return Promise.reject({ message: 'cdApi not configured' });
    };
    /**
     * Función que guarda la información en la bitácora
     *
     * Save info in Bitacora
     *
     * @param {any} event
     * @param {boolean} _showLoading
     */
    BioCatchService.prototype.saveDataInBitacora = function (event, _showLoading) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ipBiocatch, bitacoraEvent, frontmicro;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ipBiocatch = this.getCurrentScoreIp();
                        bitacoraEvent = event;
                        this.devicePrint = new LogDeviceModel();
                        this.devicePrint.device = this.abreCuentasService.getDeviceInfo();
                        frontmicro = 'onboarding-angular-fe';
                        this.devicePrint.transaction = this.abreCuentasService.getTransactionInfo();
                        this.devicePrint.transaction.transaction_type = frontmicro;
                        this.devicePrint.device.event_name = bitacoraEvent;
                        this.devicePrint.device.ip = ipBiocatch;
                        this.devicePrint.terms_type = bitacoraEvent;
                        console.log('---------saveDataInBitacora--------');
                        console.log(this.devicePrint);
                        return [4 /*yield*/, this.requestService.saveDataInBitacora(this.devicePrint)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función de revisión de los resultados de los parámetros
     *
     * Check parameter results function
     *
     * @param {any} body
     * @param {boolean} _showLoading
     * @returns {Promise}
     */
    BioCatchService.prototype.checkParameterResults = function (body, _showLoading) {
        return this.requestService
            .checkScore(body)
            .then(function (res) {
            return new Promise(function (resolve, reject) {
                if (res) {
                    if (res.status !== 200) {
                        reject({ message: 'error', code: res.status });
                    }
                    else {
                        resolve(res.body);
                    }
                }
                reject({ message: 'no response' });
            });
        });
    };
    /**
     * Función que llama el servicio de update
     *
     * Call update service
     *
     */
    BioCatchService.prototype.update = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var productSelected, product, birthDate, birthYear, ageRange, solicitationType, maritalStatus, processedMaritalStatus, occupation, deviceModel;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isLogin) {
                            return [2 /*return*/];
                        }
                        productSelected = this.abreCuentasService.getproductSelected();
                        product = productSelected.product_code;
                        birthDate = productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING ?
                            this.abreCuentasService.getEmployedContractModel().contractDate :
                            this.abreCuentasService.getCustomerData().basic.birthdate;
                        birthYear = new Date(birthDate).getFullYear();
                        ageRange = this.getAgeRange((new Date().getFullYear() - birthYear));
                        solicitationType = this.parametersService.getBiocatchContextParams().types[product];
                        maritalStatus = this.abreCuentasService.getMaritalStatusInfo();
                        processedMaritalStatus = maritalStatus.marital_status_description ? maritalStatus.marital_status_description : undefined;
                        occupation = this.abreCuentasService.getOccupationSelected() ? this.abreCuentasService.getOccupationSelected().name
                            : 'default occupation';
                        deviceModel = this.abreCuentasService.getDeviceInfo() ? this.abreCuentasService.getDeviceInfo().model : 'default model';
                        return [4 /*yield*/, this.requestService.biocatchUpdate(this.bodyFields, this.abreCuentasService.getCSID(), this.userPPID, this.abreCuentasService.getIntentoOtp().toString(), occupation, birthYear.toString(), ageRange, solicitationType, deviceModel, this.abreCuentasService.getIp(), processedMaritalStatus).then(function () {
                                return;
                            }, function () {
                                return;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función que llama el servicio de ppid y persiste la respuesta
     *
     * *Function that calls ppid service and persists the response*
     * @method get
     */
    BioCatchService.prototype.callPpid = function () {
        var _this = this;
        // this.userPPID = "d4b88ed7dfb511a011b7acde74146915be0d8dfba37a6fc22fd6a6769ef71d76";
        // this.abreCuentasService.setPPID(this.userPPID);
        this.requestService.getPpid(this.bodyFields).then(function (res) {
            _this.userPPID = res.body.data.ppid;
            _this.abreCuentasService.setPPID(_this.userPPID);
            _this.setPpidIsReady(true);
            return;
        }, function () {
            _this.setPpidIsReady(false);
            return;
        });
    };
    BioCatchService.prototype.isEvidenteCase = function () {
        return (!this.isAppUnica && !this.isLogin);
    };
    /**
     * Funicón que permite validar que el usuario cumpla:
     * 1. Entre por App
     * 2. Debe ser Cliente Nuevo
     * @returns {boolean}
     */
    BioCatchService.prototype.isAppCN = function () {
        return (this.isAppUnica && !this.isLogin);
    };
    /**
     * Funciónque que calcula el rango de edad del cliente
     *
     * *Function that calculates the clients age range
     *
     * @param age
     * @returns {string}
     */
    BioCatchService.prototype.getAgeRange = function (age) {
        var lowerNumber = Math.floor(age / 10) * 10;
        var upperNumber = Math.ceil(age / 10) * 10;
        if (lowerNumber === upperNumber) {
            upperNumber += 10;
        }
        return lowerNumber.toString() + "-" + upperNumber.toString();
    };
    BioCatchService.prototype.isVivCn = function (product) {
        return product === ProductsBiocatchEnum.VIV && !this.abreCuentasService.getPostlogin() &&
            !this.abreCuentasService.getIsPortal() ? true : false;
    };
    BioCatchService.prototype.setPpidIsReady = function (isReady) {
        this.ppidIsReady$.next(isReady);
    };
    BioCatchService.prototype.getPpidIsReady = function () {
        return this.ppidIsReady$.asObservable();
    };
    return BioCatchService;
}());
export { BioCatchService };
